import {CardHeader} from '../../../../../modules/components'
import {parseDate} from '../../../../../modules/utils'
import parseMoney from '../../../../../modules/utils/parseMoney'
import {ClinicInvoiceModel} from '../models'

interface Props {
    invoice: ClinicInvoiceModel
    isExport?: boolean
}
export default function InfoClinicInvoiceSubpage({invoice, isExport = false}: Props) {
    return (
        <div className='card'>
            <CardHeader title='Informações gerais' goBack={!isExport} />
            <div className='card-body'>
                <div className='row mb-5'>
                    <div className='col-12 col-lg-4'>
                        <label>Data referência</label>
                        <h3>{invoice.reference_at}</h3>
                    </div>
                    <div className='col-12 col-lg-4'>
                        <label>Valor do estabelecimento</label>
                        <h3
                            className={`text-${
                                invoice.status === 'PAID'
                                    ? 'success'
                                    : invoice.status === 'OPENED'
                                    ? 'info'
                                    : 'danger'
                            } m-0 me-2`}
                        >
                            {parseMoney(invoice.vn_clinic)}
                        </h3>
                    </div>
                    <div className='col-12 col-lg-4'>
                        <label>Status</label>
                        <h3
                            className={`text-${
                                invoice.status === 'PAID'
                                    ? 'success'
                                    : invoice.status === 'OPENED'
                                    ? 'info'
                                    : 'danger'
                            } m-0 me-2`}
                        >
                            {invoice.status === 'PAID'
                                ? 'Pago'
                                : invoice.status === 'OPENED'
                                ? 'Em aberto'
                                : 'Pendente'}
                        </h3>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 col-lg-4'>
                        <label>Qtd. de consultas</label>
                        <h3>{invoice.consults_count}</h3>
                    </div>
                    <div className='col-12 col-lg-4'>
                        <label>Repasse ao profissional</label>
                        <h3 className='text-dark m-0 me-2'>{parseMoney(invoice.vn_doctor)}</h3>
                    </div>
                    <div className='col-12 col-lg-4'>
                        <label>Data/Hora</label>
                        <h3>{parseDate(invoice.created_at) ?? invoice.created_at}</h3>
                    </div>
                </div>
            </div>
        </div>
    )
}
